import {
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from '@mui/material'
import useStyles from './Styles'
import { allColors } from '../../themes/Colors'

const PricingBreakdown = (props) => {
  const { data, func } = props
  const linearColorsName = allColors.linearColorsName
  const styles = useStyles()
  return (
    <Grid
      item
      xs={12}
      direction={'column'}
      style={{
        height: '90vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={2}
        className={styles.cardWidth}
        style={{
          borderRadius: 4,
          borderWidth: 1,
          height: 'auto',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ padding: 15, borderBottom: '1px solid #c6c6c6' }}>
          <Typography
            textAlign={'center'}
            style={{
              fontSize: 16,
              fontWeight: 'bold',
            }}
          >
            Payment Summary
          </Typography>
        </div>

        <div className={styles.pricingBreakdown}>
          <Grid
            container
            justifyContent='space-between'
            style={{ padding: '10px 10px' }}
          >
            <Typography style={{ fontSize: 14 }}>Amount</Typography>
            <Typography
              style={{ fontSize: 14 }}
            >{`₹${data?.orderData?.amount}`}</Typography>
          </Grid>
          <Grid
            container
            justifyContent='space-between'
            className={styles.pricingBreakdown_final}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              Payable amount
            </Typography>
            <Typography
              style={{ fontWeight: 'bold' }}
            >{`₹${data?.orderData?.amount}`}</Typography>
          </Grid>
        </div>
      </Paper>

      <Grid
        display='flex'
        justifyContent='center'
        alignItems='center'
        mb={3}
        style={{ marginTop: 10 }}
      >
        <Button
          variant={'contained'}
          sx={{
            '&.MuiButton-containedPrimary': {
              background: `linear-gradient(124deg, ${linearColorsName[0]}, ${linearColorsName[1]})`,
              ':hover': {
                background: `linear-gradient(124deg, ${linearColorsName[0]}, ${linearColorsName[1]})`,
              },
            },
            minWidth: '140px !important',
            fontWeight: 'bold !important',
            padding: 1,
          }}
          fullWidth
          onClick={() => {
            func()
          }}
        >
          {false ? (
            <CircularProgress size={28} style={{ color: '#fff' }} />
          ) : (
            `Pay ₹${data?.orderData?.amount}`
          )}
        </Button>
      </Grid>
      <Grid display='flex' justifyContent='center' alignItems='center'>
        <Typography fontSize={14} color={'#9D9D9D'}>
          + Including Applicable Charges
        </Typography>
      </Grid>
      <Grid
        display='flex'
        justifyContent='center'
        alignItems='center'
        mb={3}
        style={{ marginTop: 10 }}
      >
        <Typography fontSize={12}>Powered by&nbsp;</Typography>
        <Typography
          fontWeight={'bold'}
          fontSize={14}
          className={styles.gradientText}
        >
          AautiPay
        </Typography>
      </Grid>
    </Grid>
  )
}

export default PricingBreakdown
